export enum Teaching {
  T = 0,
  S,
}
